import * as Html from "../../util/Html.ts";
import * as rrule from "../../lib/rrule/rrule.js";
import { dateAdd, dateSet, forInputDate, format } from "../../lib/DateUtils.ts";

export {init}
Html.registerWidget('widget/form/recurrencyend',{init:init})

function rruleBuilderPublic(rec,interval,byday,date){
  if(rec==="BIWEEKLY"){
    return new rrule.RRule({
      freq: rrule.RRule.WEEKLY,
      interval:2,
      dtstart : date
    })
  }else if(rec==="DAYWEEK" || rec==="WEEKLY|1|MO,TU,WE,TH,FR"){
    return new rrule.RRule({
      freq: rrule.RRule.WEEKLY,
      byweekday: [rrule.RRule.MO,rrule.RRule.TH,rrule.RRule.WE,rrule.RRule.TU, rrule.RRule.FR],
      interval:interval,
      dtstart : date
    })
  }
  var options = {
    freq: rrule.RRule[rec],
    //byweekday:rec==='WEEKLY'?byday.map(key=>rrule.RRule[key]):undefined,
    interval:interval,
    dtstart : date
  }
  if(rec==='WEEKLY' && byday.length>0){
    options.byweekday = byday.map(key=>rrule.RRule[key]);
  }else if(rec==='MONTHLY'){
    //options.bymonthday = byday;
  }
  return new rrule.RRule(options)
}
function init(obj){
  var 
    form = obj.parents('form'),
    recurrencyInput = form.find('[name="recurrency"]'),
    intervalInput = form.find('[name="recurrencyInterval"]'),
    byDayInput = form.find('[name="byDay"]'),
    startInput = form.find('[name="startDate"],[name="dueDate"]'),
    placeholder = obj.find(".fw-placeholder"),
    options = obj.find(".fw-option"),
    never = $(options[0]),
    ondate = $(options[1]),
    onOcc = $(options[2]),
    onOccInput = onOcc.find('input'),
    ondateinput = ondate.find('input'),
    input = obj.find('input').first();

  function rruleBuilder(){
    var 
      rec = recurrencyInput.val(),
      interval = Number(intervalInput.val()),
      byday = byDayInput.val().split(/,/g).filter(t=>t!==''),
      
      date = startInput.dateValue();
    
    return rruleBuilderPublic(rec,interval,byday,date)
  }

  
  function refresh(){
    if(input.val()===''){
      input.val('$empty');
    }
    if(input.val()==='$empty'){
      placeholder.html(never.attr("placeholder"));
    }else{
      placeholder.html(ondate.attr("placeholder")+format(input.dateValue(),'L'));
    }
  }
  function setDateFromInput(){
    if(ondateinput.dateValue()){
      var date = dateSet(ondateinput.dateValue(),{hour:23,minute:59,second:59,milli:0})
      input.dateValue(date);
      return date;
    }else{
      input.val("$empty");
    }
  }
  
  function close(evt){
    evt.stopPropagation();
    setDateFromInput();
    refresh();
    obj.removeClass('fw-open')
    $(document).off("mousedown",close)
  }
  function open(evt){
    evt.stopPropagation();
    
    var value = input.val();
    ondateinput.attr('min',startInput.val().substring(0,10))
    if(value==='$empty'){
      ondateinput.val('').trigger('change');
      if(onOccInput.val()){
        onOccInput.trigger('change');
      }
    }else{
      ondateinput.val(forInputDate(new Date(input.val()))).trigger('change');
    }
    
    obj.addClass('fw-open');
    $(document).on("mousedown",close)
  }
  obj.on("mousedown",function(evt){
    evt.stopPropagation();
  })
  obj.on("click",function(evt){
    evt.stopPropagation();
    if(obj.hasClass('fw-open')){
      close(evt);
    }else{
      open(evt);
    }
  });
  never.on("click",function(evt){
    ondateinput.val('');
    close(evt);
  });
  
  
  ondate.on("click",function(evt){
    evt.stopPropagation()
    ondateinput.focus();
  });
  onOcc.on("click",function(evt){
    evt.stopPropagation()
    onOccInput.focus();
  });

  
  //update fields against each other
  onOccInput.on("change click",function(){
    var val = Number(this.value||1);
    if(val>this.max){
      this.value=this.max;
    }else if(val<this.min){
      this.value=this.min;
    }
    
    var onOccValue = Number(this.value)-1;
    
    if(!this.value || !startInput.val()){
      return;
    }
    
    var ruleSet = new rrule.RRuleSet();
    ruleSet.rrule(rruleBuilder());
    
    var LIMIT=20000;
    ruleSet.all(function(date,idx){
      if(LIMIT--<=0){throw new Error("infinite loop")}
      if(idx>=onOccValue){
        ondateinput.val(date.toISOString().substring(0,10));
        return false;
      }else{
        return true;
      }
    })  
  })
  
  ondateinput.on("change click",function(){
    
    if(!this.value || !startInput.val()){
      return;
    }
    var ruleSet = new rrule.RRuleSet();
    ruleSet.rrule(rruleBuilder());
    
    var 
      LIMIT=20000,
      onDateValue = setDateFromInput();
    ruleSet.all(function(date,idx){
      if(LIMIT--<=0){throw new Error("infinite loop")}
      if(date>=onDateValue){
        onOccInput.val(idx);
        return false;
      }else{
        return true;
      }
    })  
  })
  
  refresh();
}